// @flow
'use strict';

export const OPCOES_MANIFESTACAO = [
  { value: 'ciencia', label: 'Ciência da operação' },
  { value: 'confirmada', label: 'Confirmada' },
  { value: 'operacao_nao_realizada', label: 'Operação não realizada' },
  { value: 'desconhecida', label: 'Desconhecida' },
];
